import React from 'react'
import { string, shape, bool, node } from 'prop-types'
import { Link } from 'gatsby'
import { css } from '@emotion/react'

import StarIcon from '@/assets/icons/app-card-star.inline.svg'
import CardBase from './Base'
import Icon from './Icon'

const topPartCss = css`
  display: flex;
  margin-bottom: 5px;
  overflow: hidden;
`

const productInfoCss = css`
  display: flex;
  flex-direction: column;
  overflow: hidden;
`

const titleCss = (theme) => css`
  display: block;
  width: 100%;
  min-height: 24px;
  margin: 2px 15px 0 0;
  font-size: 18px;
  line-height: 24px;
  letter-spacing: 0.005em;
  color: ${theme.colors.primary};
  font-weight: ${theme.font.bold};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.2s ease-out;
`

const subtitleCss = (theme) => css`
  margin: 0;
  min-height: 32px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: 20px;
  white-space: nowrap;
  color: ${theme.colors.primary};

  & > span {
    width: 100%;
    font-size: 15px;
    line-height: 20px;
    opacity: 0.7;

    & span:last-of-type {
      font-size: 15px;
      overflow: hidden;
      text-overflow: ellipsis;
      opacity: 1;
    }
  }
`

const descriptionCss = (theme) => css`
  width: 100%;
  min-height: 40px;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 0.005em;
  color: ${theme.colors.gray600};
  margin: 0;
  word-break: break-word;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  transition: all 0.2s ease-out;
`

const starCss = css`
  position: absolute;
  right: -7px;
  top: -7px;
`

const linkCss = css`
  width: 100%;
  padding: 16px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
`

const ProductCard = ({
  link,
  isFeatured,
  icons,
  logo,
  title,
  subtitle,
  description,
  className,
}) => (
  <CardBase withHover className={className}>
    {isFeatured && <StarIcon css={starCss} />}

    <Link to={link} css={linkCss} aria-label={title}>
      <div css={topPartCss}>
        <Icon icons={icons} logo={logo} alt={title} />

        <section css={productInfoCss}>
          <h2 css={titleCss} className="appName">
            {title}
          </h2>

          {subtitle && <div css={subtitleCss}>{subtitle}</div>}
        </section>
      </div>

      <p css={descriptionCss}>{description}</p>
    </Link>
  </CardBase>
)

ProductCard.propTypes = {
  link: string,
  title: node,
  subtitle: node,
  description: node,
  icons: shape({
    small: string,
    original: string,
    large: string,
    title: string,
  }),
  logo: shape({
    childImageSharp: shape({
      gatsbyImageData: shape({}),
    }),
  }),
  isFeatured: bool,
  className: string,
}

export default ProductCard
